// components/WheelWrapper.js
import React, { useState } from 'react';
// import WheelPage from './WheelPage';
// import WheelPageSZ from './WheelPageSZ';
import WheelPageSZJP from './WheelPageSZJP';

const ADMIN_VARIANT = process.env.REACT_APP_ADMIN_VARIANT || 'SINGLE_ZERO'; // 'SINGLE_ZERO' or 'DOUBLE_ZERO'

// const TOGGLE_BUTTON_STYLE = {
//   position: 'fixed',
//   top: '10px',
//   right: '10px',
//   zIndex: 9999,
//   padding: '6px 12px',
//   borderRadius: '4px',
//   border: 'none',
//   cursor: 'pointer',
//   fontSize: '12px',
//   fontWeight: 'bold',
//   backgroundColor: '#222',
//   color: '#fff',
//   opacity: 0.7,
// };

const WheelWrapper = () => {
  const [variant, setVariant] = useState(ADMIN_VARIANT);

  // const handleToggle = () => {
  //   setVariant((prev) => (prev === 'SINGLE_ZERO' ? 'DOUBLE_ZERO' : 'SINGLE_ZERO'));
  // };

  const isSingleZero = variant === 'SINGLE_ZERO';

  return (
    <>
      {/* <button style={TOGGLE_BUTTON_STYLE} onClick={handleToggle}>
        {isSingleZero ? 'Switch: DOUBLE ZERO' : 'Switch: SINGLE ZERO'}
      </button> */}
      {/* SINGLE_ZERO -> WheelPageSZ (single-zero wheel), DOUBLE_ZERO -> WheelPage */}
      {/* {isSingleZero ? <WheelPageSZJP /> : <WheelPage />} */}
      {<WheelPageSZJP />}
    </>
  );
};

export default WheelWrapper;
